// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBaseTheme } from "@tps/XDL/types";
import { ellipsis, xScreen } from "@tps/XDL/Utilities";
import color from "@tps/XDL/Utilities/color";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: 14,
            color: "text.main",
            ellipsis: true,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
                max-width: 100ch;
                ${IconWrapper} {
                    color: inherit;
                }
                ${xScreen("lte", "sm")} {
                    white-space: normal;
                    ${ellipsis(1)}
                }
            `,
        },
        css: css`
            flex-wrap: wrap;
            margin-bottom: 16px;
            ${StyledButton} {
                position: relative;
                overflow: hidden;
            }
            ${StyledButton} > ${TypographyStyle} {
                color: ${color("text.main")};
            }

            ${StyledButton}:hover > ${TypographyStyle} {
                color: ${color("common.ui8")};
            }
            & > ${TypographyStyle} {
                font-size: 14px;
                font-weight: bold;
                letter-spacing: 0;
                line-height: 22px;
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];
